import { Component, OnInit, OnDestroy, ViewEncapsulation } from "@angular/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { FormBuilder } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { SchoolService } from "src/app/admin/service/school.service";
import { AuthService } from "../auth.service";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { ConfirmationService } from "primeng/api";
import { MessageService } from "primeng/api";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "app-login",
  templateUrl: "./student-certificate.component.html",
  encapsulation: ViewEncapsulation.None,
  styleUrls: ["./student-certificate.component.css"],
  providers: [MessageService, ConfirmationService],
})
export class StudentCertificateComponent implements OnDestroy, OnInit {
  private destroy$ = new Subject<void>();
  StudentCertificate;
  netImage: any = "assets/images/general/isso_logo.png";
  eventId: string;
  eventYear: string;
  errormessage: boolean;
  loginForm: FormGroup;
  submitted = false;
  returnUrl: string;
  error: { errorTitle: ""; errorDesc: "" };
  loginError: string;
  certificateData: any;

  name = "Google Font Tester";
  fontFamilyInput: string = "Gaegu";
  fontFamily: string = "roboto";
  fontUri: string = null;
  randomstring: string;
  gameId: string;
  schoolId: string;
  studentId: string;
  loading: boolean;
  isShowLoader: boolean;
  imagepath = "../../assets/images/goodsport.JPG";
  rank: string;
  subgameId: string;
  isMerit: boolean = false;
  rankText: string;
  /** A merit position the server could not confirm from its own records. */
  rankUnconfirmed = false;
  showTime: boolean;
  showNoQrData: boolean = false;
  certificateYear: any;
  /** Object URL for the rendered certificate, bound into the viewer. */
  pdfUrl: any = null;
  pdfFailed = false;
  constructor(
    private authService: AuthService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.eventId = this.route.snapshot.paramMap.get("eventId");
    this.gameId = this.route.snapshot.paramMap.get("gameId");
    this.schoolId = this.route.snapshot.paramMap.get("schoolId");
    this.studentId = this.route.snapshot.paramMap.get("studentId");
    this.subgameId = this.route.snapshot.paramMap.get("subgameId");
    this.rank = this.route.snapshot.paramMap.get("rank");
    this.randomstring = this.route.snapshot.paramMap.get("randomstring");
    this.getCertificateData();
    //this.getCertificateData('27','30','1','143')
    this.loading = true;
  }
  getCertificateData() {
    if (this.rank == "norank") {
      this.isMerit = false;
    } else {
      this.isMerit = true;
      if (this.rank == "1") {
        this.rankText = "FIRST";
      } else if (this.rank == "2") {
        this.rankText = "SECOND";
      } else {
        this.rankText = "THIRD";
      }
    }
    // this.getCertificateData('2022-2023','5','9','143')
    this.isShowLoader = true;
    // PUBLIC endpoint - no Authorization header. This page is what a QR scan lands
    // on, and its audience is whoever holds the printed certificate: a parent, an
    // admissions desk, a selector. It used to call the authenticated
    // results/certificate-data, so every one of them got a 401 and a blank page.
    // The QR's own token is what authorises the read; the ids in the URL are only
    // a lookup hint and the server re-reads every field off the matched record.
    this.http
      .get(
        // environment.baseUrl is '/api/' in prod - a hardcoded host here meant
        // this call went to the viewer's own machine outside local dev.
        // Every segment of the scanned link is forwarded: certificates printed
        // before the migration store their QR under a hash of the whole URL, so
        // the server needs all of them to recognise one.
        environment.baseUrl + 'public/certificate?eventId=' + this.eventId +
          '&gameId=' + this.gameId + '&schoolId=' + this.schoolId +
          '&studentId=' + this.studentId + '&subgameId=' + this.subgameId +
          '&rank=' + this.rank + '&token=' + this.randomstring
      )
      .pipe(takeUntil(this.destroy$)).subscribe(
        (response) => {
          // this.authService.getCertificateData(27,1,30,7075,'nosubgame','norank').pipe(takeUntil(this.destroy$)).subscribe(response => {
          if (response !== "") {
            this.isShowLoader = false;
            this.certificateData = response;
            this.certificateData.length;
            this.certificateYear = response[0].event_year;

            // Merit or participation, and which position, come from the record -
            // not from the URL, which anyone can edit. A doctored link must not be
            // able to make this page assert a rank that was never awarded.
            this.isMerit = !!response[0].rank;
            this.rankText = response[0].rankText || "";
            // Older codes carry no position of their own. Say so plainly rather
            // than presenting an unconfirmed claim as a verified one.
            this.rankUnconfirmed = this.isMerit && response[0].rankVerified === false;

            this.loadPdf();

            if (this.certificateData.length == 1) {
              let timeDistanceVal = this.certificateData[0]["timeDistance"];
              // if(timeDistanceVal === undefined) {
              //   this.showTime = false;
              // } else {
              //   this.showTime = true;
              // }
              if (
                timeDistanceVal === undefined ||
                timeDistanceVal === null ||
                timeDistanceVal.toString().trim() === ""
              ) {
                this.showTime = false;
              } else {
                this.showTime = true;
              }
            } else {
              this.showNoQrData = true;
            }

            //this.schoolServiceData =response;
            //this.schoolData = this.schoolServiceData;
          } else {
          }
        },
        (error) => {
          // A token that matches no certificate 404s. Stop the spinner and show the
          // not-found panel - it used to spin forever, which read as a broken page
          // rather than as "this certificate did not check out".
          this.isShowLoader = false;
          this.showNoQrData = true;
        }
      );
  }
  /**
   * Fetch the certificate as a PDF and show it.
   *
   * The page used to redraw the certificate in HTML, with its own rule for
   * which artwork era applied - a third rule alongside the generator's two,
   * and keyed to the calendar year, so it drifted every 1 January and showed a
   * different document from the one the student downloaded. It now displays
   * what the generator produced.
   */
  loadPdf() {
    const qs =
      'eventId=' + this.eventId + '&gameId=' + this.gameId +
      '&schoolId=' + this.schoolId + '&studentId=' + this.studentId +
      '&subgameId=' + this.subgameId + '&rank=' + this.rank +
      '&token=' + this.randomstring;
    this.http
      .get(environment.baseUrl + 'public/certificate-pdf?' + qs, { responseType: 'blob' })
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (blob: Blob) => {
          this.objectUrl = URL.createObjectURL(blob);
          // Angular blocks blob: URLs in [src] without this.
          this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl);
        },
        // The verified details are already on screen; only the picture of the
        // certificate is missing, so say so rather than blanking the page.
        () => { this.pdfFailed = true; },
      );
  }

  private objectUrl: string | null = null;

  ngOnDestroy() {
    if (this.objectUrl) { URL.revokeObjectURL(this.objectUrl); }
    this.destroy$.next();
    this.destroy$.complete();
  }

}
